export interface StaticConfig {
    controlServer: string;
    sessionProvider: string;
    sessionServer: string;
    windowsClientVersion: string;
    linuxClientVersion: string;
    macOSClientVersion: string;
    features: SessionFeatureSupport;
    contentService: string
  }

  export interface SessionFeatureSupport{
    video: boolean | string;
    audio: boolean | string;
    fileSharing: boolean | string;
    sessionRecording: boolean | string;
    oneToOneChat: boolean | string;
  }

  export enum DeviceInputOutputType {
    audioinput = "audioinput",
    audiooutput = "audiooutput",
    videoinput = "videoinput"
  }
